import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router";
import moment from "moment";

export default function CouponDetails() {
  const [coupon, setCoupon] = useState({});
  const [users, setUsers] = useState([]);
  // const [usedby, setUsedBy] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [couponLoaded, setCoupLoaded] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const getCouponById = async (id) => {
      const [couponResponse, res] = await Promise.all([
        axios.get(`/api/coupon/${id}`),
        axios.get(`/api/coupon/getcouponforchef/${coupon.restaurant_id}/${coupon.status}`)
      ]);
      setCoupon(couponResponse.data);
      setCoupLoaded(true);
      // setUsedBy(res.data.unique);
      setUsers(res.data.promotedOrders);
      setLoaded(true);
    };

    getCouponById(id);
  }, [id, coupon.restaurant_id]);

  if (loaded && couponLoaded) {
    const {
      status,
      promo_id,
      restaurant_id,
      category,
      plan_name,
      discount_type,
      promo_code,
      price,
      discount,
      absolute_value,
      start_date,
      end_date
    } = coupon;

    return (
      <div className="ibox">
        <div className="ibox-title">
          <span className={`label float-right ${status === "Active" ? "label-success" : "label-warning"}`}>
            {status}
          </span>
          <h5>Coupon Details</h5>
        </div>
        <div className="ibox-content">
          <div className="row">
            <div className="col-lg-4">
              <small className="stats-label">Promotion ID</small>
              <h4>{promo_id}</h4>
            </div>
            <div className="col-lg-4">
              <small className="stats-label">Restaurant ID</small>
              <h4>{restaurant_id}</h4>
            </div>
            <div className="col-lg-4">
              <small className="stats-label">Category</small>
              <h4>{category}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <small className="stats-label">Plan Name</small>
              <h4>{plan_name}</h4>
            </div>
            <div className="col-lg-4">
              <small className="stats-label">Discount Type</small>
              <h4>{discount_type}</h4>
            </div>
            <div className="col-lg-4">
              <small className="stats-label">Code</small>
              <h4>{promo_code}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <small className="stats-label">Base Price</small>
              <h4>{price}</h4>
            </div>
            <div className="col-lg-4">
              <small className="stats-label">Value</small>
              <h4>{discount}</h4>
            </div>
            <div className="col-lg-4">
              <small className="stats-label">Absolute Value</small>
              <h4>{absolute_value}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <small className="stats-label">Total Used</small>
              <h4>{users.length}</h4>
            </div>
            <div className="col-lg-4">
              <small className="stats-label">Start Date</small>
              <h4>{start_date}</h4>
            </div>
            <div className="col-lg-4">
              <small className="stats-label">End Date</small>
              <h4>{end_date}</h4>
            </div>
          </div>
          <table className="table table-bordered mt-4">
            <thead>
              <tr>
                <th>User ID</th>
                <th>Order ID</th>
                <th>Meal Type</th>
                <th>Ordered At</th>
                <th>Discount</th>
              </tr>
            </thead>
            <tbody>
              {users.map((data, key) => (
                <tr key={key}>
                  <td>{data.user_id}</td>
                  <td>{data.order_id}</td>
                  <td>{data.meal_type}</td>
                  <td>{moment(data.order_time).format("DD/MMM/YYYY")}</td>
                  <td>{"$" + data.discount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
